import { combineReducers, configureStore, PreloadedState } from '@reduxjs/toolkit';
import globalState from './globalStateSlice';
import moduleState from './moduleStateSlice';

const rootReducer = combineReducers({
    globalState: globalState.reducer,
    moduleState: moduleState.reducer,
});

export const store = configureStore({
    reducer: rootReducer
});

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState
    });
};

export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;